module.exports = {"notifications":"Notificacions"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/Notifications.json
// module id = 594
// module chunks = 1